import { Injectable } from '@angular/core';
import { IDeviceIdComponents } from '@trent/models/fcm/fcm-token-data';

@Injectable()
export abstract class IdeviceIdService {
  platformInfo: () => Promise<string>;
  getDeviceId: () => Promise<IDeviceIdComponents>;
}
